// extracted by mini-css-extract-plugin
export var contentOrigin = "FCj1v";
export var root = "_19YaC";